import HttpErrorInterceptor from './service/HttpErrorInterceptor';
import ErrorService from './service/ErrorService';
import {DvErrorMessagesPanelComponentConfig} from './directive/dvb-error-messages/dvb-error-messages-panel';
let style = require('./errors.scss');
/***
 * Modul fuer Errordarstellung
 * @type {angular.IModule}
 */
export const DVBernErrors: angular.IModule = angular.module('dvbAngular.errors', ['ui.bootstrap', 'ui.router', 'ngAnimate'])
    .service('ErrorService', ErrorService)
    .service('HttpErrorInterceptor', HttpErrorInterceptor)
    .component('dvbErrorMessagesPanel', new DvErrorMessagesPanelComponentConfig());




// WEBPACK FOOTER //
// ./src/app/core/errors/errors.ts